export class RevealPanel {
    trigger: HTMLButtonElement | null;
    panel: HTMLElement;
    isOpen: boolean = false;
    openHandlers: Array<any>;
    closeHandlers: Array<any>;

    constructor(panel: HTMLElement | string) {
        this.openHandlers = [];
        this.closeHandlers = [];
        let panelId = typeof panel == 'string' ? panel : (panel as HTMLElement).id;
        this.panel = document.querySelector<HTMLElement>(`#${panelId}`)!;
        this.trigger = document.querySelector(`[aria-controls="${panelId}"]`);
        if (!!this.panel) {
            this.addEventListeners();
            const stayOpen = this.panel.getAttribute('aria-hidden') == 'false';
            if (stayOpen) {
                this.openPanel();
            }
            else {
                this.closePanel();
            }
        }
    }

    addEventListeners() {
        if (!!this.trigger) {
            this.trigger!.addEventListener('click', () => {
                if (this.isOpen) {
                    this.closePanel();
                }
                else {
                    this.openPanel();
                }
            });
        }
    }

    on(event: string, handler: () => void) {
        switch (event) {
            case "open":
                return this.openHandlers.push(handler);
            case "close":
                return this.closeHandlers.push(handler);
        }
    }

    closePanel() {
        this.panel.setAttribute('inert', '');
        this.panel.setAttribute('aria-hidden', 'true');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.isOpen = false;

        if (this.closeHandlers) {
            this.closeHandlers.forEach(handler => {
                setTimeout(handler.bind(this), 0);
            })
        }
    }

    openPanel() {
        this.panel.removeAttribute('inert');
        this.panel.setAttribute('aria-hidden', 'false');
        this.trigger?.setAttribute('aria-expanded', 'true');
        this.isOpen = true;

        if (this.openHandlers) {
            this.openHandlers.forEach(handler => {
                setTimeout(handler.bind(this), 0);
            })
        }
    }
}